import { useEffect } from 'react';
import styles from './registration.module.css';

import constants from '../../../constants.js';

import { useSidebarProvider } from '../../../providers/SidebarProvider.js';

import { FilloutStandardEmbed } from '@fillout/react';

const Registration = ({ setSelectedMenuItem, title, form }) => {

  const isTally = form.includes('tally.so');
  const tallyQuery = "?hideTitle=1&transparentBackground=1&dynamicHeight=1";

  const isFillout = form.includes('fillout.com');
  const getFilloutId = (form) => form.split('/').pop(); // extracts id from URL

  const { setIsSidebarShowing } = useSidebarProvider();

  useEffect(() => {
    // If the page is loading on a small width, hide the sidebar so you see the page
    if (window.innerWidth < 1300){
      setIsSidebarShowing(false);
    }
    
    let page = "";
    if (title === constants.titles.teamRegistration)
        page = constants.pages.teamRegistration;
    else if (title === constants.titles.clubRegistration)
        page = constants.pages.clubRegistration;
    else if (title === constants.titles.playerRegistration){
        page = constants.pages.playerRegistration;
    }
    else if (title === constants.titles.localRegistration) {
        page = constants.pages.localRegistration;
    }

    setSelectedMenuItem("");

    if (isTally) {
      const widgetScriptSrc = 'https://tally.so/widgets/embed.js';

      const load = () => {
        // Load Tally embeds
        if (typeof Tally !== 'undefined') { // eslint-disable-next-line no-undef
          Tally.loadEmbeds(); // eslint-disable-next-line no-undef
          return;
        }

        // Fallback if window.Tally is not available
        document
          .querySelectorAll('iframe[data-tally-src]:not([src])')
          .forEach((iframeEl) => {
            iframeEl.src = iframeEl.dataset.tallySrc;
          });
      };
      
      // If Tally is already loaded, load the embeds
      if (typeof Tally !== 'undefined') { // eslint-disable-next-line no-undef
        load();
        return;
      }

      // If the Tally widget script is not loaded yet, load it
      if (document.querySelector(`script[src="${widgetScriptSrc}"]`) === null) {
        const script = document.createElement('script');
        script.src = widgetScriptSrc;
        script.onload = load;
        script.onerror = load;
        document.body.appendChild(script);
        return;
      }
    }
  }, [form]);

  return (
    <div className={styles.Registration}>
      <div className={styles.Title}>{title}</div>
      {isTally ? <iframe
        allow="payment"
        data-tally-src={form + tallyQuery}
        loading="lazy"
        width="100%"
        title="Registration form"
        key={form}>
      </iframe>
      : isFillout ? 
      <FilloutStandardEmbed
          filloutId={getFilloutId(form)}
          inheritParameters/>
      : <iframe
        allow="payment"
        src={form}
        loading="lazy"
        width="100%"
        height="100%"
        title="Player Registration Form"
        key={form}>
      </iframe>}

    </div>
  )
}

export default Registration;